import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MonitorIcon, ShoppingCartIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
export function PricingPreview() {
  const handleBronzeClick = () => {
    window.open('https://buy.stripe.com/aFa14hfmQ5ga8v85gsaZi00', '_blank');
  };
  const handleSilverClick = () => {
    window.open('https://buy.stripe.com/eVqcMZ3E8cICbHk4coaZi01', '_blank');
  };
  const handleGoldClick = () => {
    window.open('https://buy.stripe.com/eVq3cpfmQ6ke8v86kwaZi02', '_blank');
  };
  const pricingOptions = [{
    icon: MonitorIcon,
    packageName: 'Standard Package',
    title: 'Web Design',
    price: '£399',
    priceLabel: 'Starting from',
    description: 'Professional websites that convert visitors into customers',
    link: '/web-design',
    gradient: 'from-blue-500 via-blue-600 to-indigo-700',
    features: ['Responsive mobile-friendly design', 'SEO optimized for Google', 'Fast loading speeds', 'Contact forms & integration'],
    hasPaymentLinks: true
  }, {
    icon: ShoppingCartIcon,
    packageName: 'E-Commerce Package',
    title: 'E-Commerce',
    subtitle: '(Online Retail Stores)',
    price: '£838.80',
    priceLabel: 'Starting from',
    description: 'Complete online stores for fashion, toys, electronics & more',
    link: '/ecommerce',
    gradient: 'from-purple-500 via-purple-600 to-pink-600',
    features: ['Unlimited products', 'Secure payment processing', 'Inventory management', 'Shopping cart & checkout'],
    hasPaymentLinks: false
  }, {
    icon: ShieldCheckIcon,
    packageName: 'Maintenance Package',
    title: 'Website Care',
    subtitle: '(Monthly or One-off)',
    price: '£79',
    priceLabel: 'Monthly from',
    description: 'Keep your site secure, fast and up-to-date',
    link: '/website-care',
    gradient: 'from-green-500 via-emerald-600 to-teal-600',
    features: ['Security monitoring & updates', 'Regular backups', 'Performance optimization', 'Priority support'],
    hasPaymentLinks: false
  }];
  return <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-b from-white to-gray-50 dark:from-[#1E1E1E] dark:to-[#121212]" data-id="element-340">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-341">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-342">
          <motion.span initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="inline-block px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-full text-sm font-medium mb-4 shadow-lg" data-id="element-343">
            ✨ Transparent Pricing
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-[clamp(1.75rem,4vw,2.5rem)] font-bold mb-4 text-[#0C1B26] dark:text-white" data-id="element-344">
            Affordable Solutions for Every Business
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-base md:text-lg text-gray-600 dark:text-gray-300" data-id="element-345">
            Clear, upfront pricing with no hidden fees. All prices include VAT.
          </motion.p>
        </div>
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-346">
          {pricingOptions.map((option, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -8,
          scale: 1.02
        }} className="relative" data-id="element-347">
              <div className="block bg-white dark:bg-[#1E1E1E] rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group h-full border-2 border-transparent hover:border-white/20" data-id="element-348">
                <div className={`absolute inset-0 bg-gradient-to-br ${option.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-300`} data-id="element-349" />
                <div className="relative p-6 md:p-8" data-id="element-350">
                  <Link to={option.link} className={`inline-block mb-4 text-sm font-bold uppercase tracking-wide bg-gradient-to-r ${option.gradient} bg-clip-text text-transparent hover:underline`} data-id="element-351">
                    {option.packageName}
                  </Link>
                  <div className={`w-16 h-16 bg-gradient-to-br ${option.gradient} rounded-2xl flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 group-hover:rotate-3 transition-all duration-300`} data-id="element-352">
                    <option.icon size={32} className="text-white" data-id="element-353" />
                  </div>
                  <div className="mb-4" data-id="element-354">
                    <h3 className="text-xl md:text-2xl font-bold text-[#0C1B26] dark:text-white" data-id="element-355">
                      {option.title}
                    </h3>
                    {option.subtitle && <p className="text-sm text-gray-500 dark:text-gray-400 mt-1" data-id="element-356">
                        {option.subtitle}
                      </p>}
                  </div>
                  <div className="mb-4" data-id="element-357">
                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-1" data-id="element-358">
                      {option.priceLabel}
                    </p>
                    <div className="flex items-baseline" data-id="element-359">
                      <span className={`text-4xl md:text-5xl font-bold bg-gradient-to-r ${option.gradient} bg-clip-text text-transparent`} data-id="element-360">
                        {option.price}
                      </span>
                      <span className="text-gray-600 dark:text-gray-400 ml-2" data-id="element-361">
                        {option.price.includes('£79') ? '/month' : 'Inc VAT'}
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed" data-id="element-362">
                    {option.description}
                  </p>
                  <ul className="space-y-3 mb-6" data-id="element-363">
                    {option.features.map((feature, featureIndex) => <li key={featureIndex} className="flex items-start" data-id="element-364">
                        <CheckIcon size={18} className={`mt-0.5 mr-2 flex-shrink-0 bg-gradient-to-r ${option.gradient} bg-clip-text text-transparent`} data-id="element-365" />
                        <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-366">
                          {feature}
                        </span>
                      </li>)}
                  </ul>
                  {option.hasPaymentLinks ? <div className="space-y-3" data-id="element-367">
                      <button onClick={handleBronzeClick} className={`w-full flex items-center justify-center py-2.5 px-4 rounded-lg bg-gradient-to-r ${option.gradient} text-white font-medium hover:shadow-xl transition-all duration-300 text-sm`} data-id="element-368">
                        <span data-id="element-369">Bronze - £399</span>
                      </button>
                      <button onClick={handleSilverClick} className={`w-full flex items-center justify-center py-2.5 px-4 rounded-lg bg-gradient-to-r ${option.gradient} text-white font-medium hover:shadow-xl transition-all duration-300 text-sm`} data-id="element-370">
                        <span data-id="element-371">Silver - £599</span>
                      </button>
                      <button onClick={handleGoldClick} className={`w-full flex items-center justify-center py-2.5 px-4 rounded-lg bg-gradient-to-r ${option.gradient} text-white font-medium hover:shadow-xl transition-all duration-300 text-sm`} data-id="element-372">
                        <span data-id="element-373">Gold - £899</span>
                      </button>
                      <Link to={option.link} className="block text-center py-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 transition-colors" data-id="element-374">
                        View full details →
                      </Link>
                    </div> : <Link to={option.link} className={`flex items-center justify-center py-3 px-6 rounded-xl bg-gradient-to-r ${option.gradient} text-white font-semibold group-hover:shadow-xl transition-all duration-300`} data-id="element-375">
                      <span data-id="element-376">View Packages</span>
                      <ArrowRightIcon size={18} className="ml-2 group-hover:translate-x-1 transition-transform duration-300" data-id="element-377" />
                    </Link>}
                </div>
              </div>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center mt-10" data-id="element-378">
          <Link to="/pricing" className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold rounded-xl hover:shadow-xl hover:scale-105 transition-all duration-300" data-id="element-379">
            <span data-id="element-380">Compare All Packages</span>
            <ArrowRightIcon size={18} data-id="element-381" />
          </Link>
        </motion.div>
      </div>
    </section>;
}